module.exports = {"true":"Ja","false":"Nein"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/general.json
// module id = +fp/
// module chunks = 1